module.exports = __webpack_public_path__ + "media/src/img/not_home_video-b2863f2a316faa0f40e084d40fccfc4f.jpeg";